import { FormControlLabel, Grid, TextField } from "@mui/material";
import { CustomSwitch } from "../../../../../Layout/Switch/CustomSwitch";
import { LanguageConsumer } from "../../../../../Infrastructure/Internationalisation/TranslationService";
import { SingleClaim } from "./Models/ClaimsEditResponseDto";

interface ClaimsEditSingleProps {
    item: SingleClaim,
    handleCheckedChange: (item: SingleClaim) => void,
    handleTextChange: (item: SingleClaim, text: string) => void
}

export const ClaimsEditSingle = (props: ClaimsEditSingleProps) => {
    const { item, handleCheckedChange, handleTextChange } = props;

    return (
        <LanguageConsumer>
            {({ getTranslatedText }) =>
                <>
                    <Grid container direction={'row'} spacing={2} sx={{ mt: -1 }}>
                        <Grid item xs={12} my={'auto'}>

                            <FormControlLabel sx={{ ml: 2 }} control={<CustomSwitch />}
                                checked={props.item.IsEnabled}
                                disabled={false}
                                label={getTranslatedText(item.Claim.toString())}
                                onChange={() => handleCheckedChange(item)}
                            />
                        </Grid>
                        {item.IsEnabled && item.CanHasValue && <Grid item xs={9} my={'auto'}>
                            <TextField fullWidth value={item.Value} onChange={e => handleTextChange(item, e.target.value)}></TextField>

                        </Grid>}
                    </Grid>
                </>
            }
        </LanguageConsumer>
    )
}